import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LBatchSigning } from 'core/config';
import { Subject, distinctUntilChanged, filter, map } from 'rxjs';
import { ActorCardItemService } from '../actor-card-item/actor-card-item.service';



@Component({
  selector: 'ss-actor-settings',
  templateUrl: './actor-settings.component.html',
  styleUrls: ['./actor-settings.component.scss'],
  host: {
    class: 'flex-column gap-small padding-small'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActorSettingsComponent {
  readonly #destroy = new Subject<void>()


  readonly activitySubject = this._actorCardItemService.activitySubject;
  get #activity() {
    return this.activitySubject.value
  }
  readonly batchSigningDataSource = this._actorCardItemService.batchSigningDataSource
  readonly batchSigningSubject = this._actorCardItemService.batchSigningSubject
  readonly valueObs = this.batchSigningSubject.pipe(
    filter(Boolean),
    map((batchSigning) => !batchSigning ? null : this.batchSigningDataSource.find(({ value }) => value === batchSigning)),

    distinctUntilChanged()
  )

  constructor(
    private readonly _actorCardItemService: ActorCardItemService,

  ) {

  }


  ngAfterViewInit() { }

  setActivityBatchSigning(batchSigning: LBatchSigning) {

    this._actorCardItemService.setActivityBatchSigning(batchSigning)
  }


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
